import React from 'react';

import { BrailleInput } from '../../../components';
import { BRAILLE } from '../../../symbols';

interface DrawWordCurrentProps {
  challenge: string | null;
  drawnSymbols: BRAILLE[];
  onSymbolChange: (index: number, value: BRAILLE) => void;
}

export const DrawWordCurrent = ({ challenge, drawnSymbols, onSymbolChange }: DrawWordCurrentProps) => {
  if (challenge === null) {
    return (
      <div className="prose mb-8">
        <p className="text-red-500">
          Found no words matching the symbols you have selected. Try to select some more :)
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="prose mb-4">
        <h2>{challenge}</h2>
      </div>
      <div className="flex flex-row flex-wrap justify-center">
        {drawnSymbols.map((value, index) => (
          <BrailleInput key={index} value={value} onChange={(newValue) => onSymbolChange(index, newValue)} />
        ))}
      </div>
    </>
  );
};
